import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

import { User, UserGoal } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersMutations, UsersState } from '@/stores/users.store';
import { computed, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserGoals',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { us: UsersState }>();
const goals = computed<UserGoal[]>(() => store.state.us.userGoals);
const loaded = ref<boolean>(false);

const props = __props;

function loadGoals() {
  store.dispatch(UsersActions.GetGoals, props.user.id);
  loaded.value = true;
}

function deleteUserGoal(id: number) {
  if (
    confirm(
      'This will delete the user goal, and all the items associated with it',
    )
  ) {
    store.dispatch(UsersActions.DeleteUserGoal, {
      id,
      userId: props.user.id,
    });
  }
}

watch(
  () => props.user,
  () => {
    store.commit(UsersMutations.SetGoals, []);
    loaded.value = false;
  },
);

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Text', key: 'goal.title', width: '65%' },
  { title: 'Main', key: 'main', width: '10%' },
  { title: 'Options', key: 'options', width: '20%' },
];

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (__props.user.id !== -1)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "mt-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Goals")
            ])),
            _: 1
          }),
          (!goals.value.length && !loaded.value)
            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: loadGoals,
                    color: "info",
                    density: "compact"
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("See user goals")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table, {
                    items: goals.value,
                    headers: headers
                  }, {
                    "item.main": _withCtx(({ value }) => [
                      _createTextVNode(_toDisplayString(value ? 'Yes' : 'No'), 1)
                    ]),
                    "item.options": _withCtx(({ item }) => [
                      _createVNode(_component_v_btn, {
                        density: "compact",
                        icon: "mdi-delete-outline",
                        disabled: item.main,
                        onClick: ($event: any) => (deleteUserGoal(item.goal.id))
                      }, null, 8, ["disabled", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["items"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})